"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortOutcomes = exports.sortProbabilities = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const strings_1 = require("../../../../strings");
const sortFn = (parameterTypeOrder) => (p1, p2) => {
    var _a, _b;
    if (!(parameterTypeOrder === null || parameterTypeOrder === void 0 ? void 0 : parameterTypeOrder.parameterType) || !(parameterTypeOrder === null || parameterTypeOrder === void 0 ? void 0 : parameterTypeOrder.direction)) {
        return 0;
    }
    const paramValue1 = (_a = p1.parameters.find((p) => p.type === parameterTypeOrder.parameterType)) === null || _a === void 0 ? void 0 : _a.value;
    const paramValue2 = (_b = p2.parameters.find((p) => p.type === parameterTypeOrder.parameterType)) === null || _b === void 0 ? void 0 : _b.value;
    if (!paramValue1 || !paramValue2)
        return 0;
    if (paramValue1 === paramValue2)
        return 0;
    if ((0, strings_1.isNumeric)(paramValue1) && (0, strings_1.isNumeric)(paramValue2)) {
        return parameterTypeOrder.direction === betweb_openapi_axios_1.OrderDirection.Asc
            ? Number(paramValue1) - Number(paramValue2)
            : Number(paramValue2) - Number(paramValue1);
    }
    if ([
        betweb_openapi_axios_1.ParameterType.GoalsRange,
        betweb_openapi_axios_1.ParameterType.PointRange,
        betweb_openapi_axios_1.ParameterType.Range,
        betweb_openapi_axios_1.ParameterType.ExactGoals,
        betweb_openapi_axios_1.ParameterType.Exact,
    ].includes(parameterTypeOrder.parameterType)) {
        // 1-3, 4-6, 6+ range
        // 1 1+, 2 2+ exact
        let paramValue1Number;
        let paramValue2Number;
        if ((0, strings_1.isNumeric)(paramValue1)) {
            paramValue1Number = Number(paramValue1);
        }
        if ((0, strings_1.isNumeric)(paramValue2)) {
            paramValue2Number = Number(paramValue2);
        }
        if (paramValue1.includes('-')) {
            paramValue1Number = Number(paramValue1.split('-')[0]);
        }
        if (paramValue2.includes('-')) {
            paramValue2Number = Number(paramValue2.split('-')[0]);
        }
        if (paramValue1.includes('+')) {
            paramValue1Number = Number(paramValue1.split('+')[0]);
        }
        if (paramValue2.includes('+')) {
            paramValue2Number = Number(paramValue2.split('+')[0]);
        }
        if (typeof paramValue1Number === 'number' &&
            typeof paramValue2Number === 'number') {
            return parameterTypeOrder.direction === betweb_openapi_axios_1.OrderDirection.Asc
                ? paramValue1Number - paramValue2Number
                : paramValue2Number - paramValue1Number;
        }
    }
    return parameterTypeOrder.direction === betweb_openapi_axios_1.OrderDirection.Asc
        ? paramValue1.localeCompare(paramValue2)
        : paramValue2.localeCompare(paramValue1);
};
const sortProbabilities = (probs, outcomeTypeId, orderedBy) => {
    if (orderedBy === null || orderedBy === void 0 ? void 0 : orderedBy.outcomeTypeOrderedBy) {
        const { outcomeTypeOrderedBy } = orderedBy;
        if (outcomeTypeOrderedBy.schema === 'CommonOutcomeTypeOrders') {
            const { items } = outcomeTypeOrderedBy;
            if (items) {
                const parameterTypeOrder = items[0];
                // TODO check by multiple params
                if (parameterTypeOrder) {
                    probs.sort(sortFn(parameterTypeOrder));
                }
            }
        }
        else if (outcomeTypeOrderedBy.schema === 'OutcomeTypeSpecificOrders') {
            const { items } = outcomeTypeOrderedBy;
            items === null || items === void 0 ? void 0 : items.forEach((item) => {
                if (item.outcomeTypeId === outcomeTypeId) {
                    const parameterTypeOrder = item.orderedBy[0];
                    // TODO check by multiple params
                    if (parameterTypeOrder) {
                        probs.sort(sortFn(parameterTypeOrder));
                    }
                }
            });
        }
    }
};
exports.sortProbabilities = sortProbabilities;
const sortOutcomes = (probs, outcomeTypeId, orderedBy) => {
    const sortedOutcomes = [...probs];
    if (!(orderedBy === null || orderedBy === void 0 ? void 0 : orderedBy.outcomeTypeOrderedBy)) {
        return sortedOutcomes;
    }
    const { outcomeTypeOrderedBy } = orderedBy;
    if (outcomeTypeOrderedBy.schema === 'CommonOutcomeTypeOrders') {
        const { items } = outcomeTypeOrderedBy;
        if (items) {
            const parameterTypeOrder = items[0];
            // TODO check by multiple params
            if (parameterTypeOrder) {
                sortedOutcomes.sort(sortFn(parameterTypeOrder));
                return sortedOutcomes;
            }
        }
    }
    if (outcomeTypeOrderedBy.schema === 'OutcomeTypeSpecificOrders') {
        const { items } = outcomeTypeOrderedBy;
        items === null || items === void 0 ? void 0 : items.forEach((item) => {
            if (item.outcomeTypeId === outcomeTypeId) {
                const parameterTypeOrder = item.orderedBy[0];
                // TODO check by multiple params
                if (parameterTypeOrder) {
                    sortedOutcomes.sort(sortFn(parameterTypeOrder));
                }
            }
        });
        return sortedOutcomes;
    }
    return sortedOutcomes;
};
exports.sortOutcomes = sortOutcomes;
//# sourceMappingURL=sortProbabilities.js.map